import { WSCard, WSText } from "@wingspanhq/fe-component-library";
import { queriesRequirements, queriesPayerRows } from "@query";
import { RequirementType } from "@wingspanhq/wingspan-api-sdk";

import { useSession } from "@hooks/useSession";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";

export const CardAdditionalRequirementsRequester = () => {
  const { accountId } = useSession();

  // TODO(v3-blocker): v1 also filtered on `payerPayeeEngagementIds != null`;
  // v3 `listPayeeRequirements` has no existence operator, so that constraint
  // is dropped.
  const queryRequirements =
    queriesRequirements.listPayeeRequirements.useQueryAll(
      {
        filter: {
          payeeAccountId: { in: [accountId] },
          type: {
            notIn: [
              RequirementType.REGISTRATION,
              RequirementType.PAYOUT_METHOD,
              RequirementType.TAX_VERIFICATION
            ]
          }
        }
      },
      { enabled: !!accountId }
    );

  const payerIds = (queryRequirements.flatData || [])
    .map(requirement => requirement.payerAccountId)
    .filter((payerId): payerId is string => !!payerId);

  const queryPayers = queriesPayerRows.searchPayerRows.useQueryAll({
    filter: {
      payerAccountId: {
        anyOf: payerIds
      }
    }
  });

  const payerNames = (queryPayers.flatData || []).map(payer =>
    selectorSearchRowName(payer)
  );

  return (
    <WSCard header="Additional client requirements">
      <WSText.ParagraphSm color="gray600">
        Complete these additional requirements as required by{" "}
        {payerNames.join(", ")} to work with them.
      </WSText.ParagraphSm>
    </WSCard>
  );
};
